import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { hostListQueries } from '@/services/hostManagement/hostManagement.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from '@tanstack/react-router';
import { toast } from 'sonner';

const useAddHostInfo = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const params = useParams({ from: '/(app)/store-information/premium-stores/host-management/$clubid' });
  const { mutateAsync } = useMutation('createHostInfo', {
    onError: (err) => {
      toast.error(err.message);
    },
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: [...hostListQueries.all()] });
      toast.success(res.message);
      void navigate({
        to: '/store-information/premium-stores/host-management/$clubid',
        params: {
          clubid: params['clubid'],
        },
      });
      await revalidate(['hostDetail', 'clubHosts', 'editorRecommendedStores']);
    },
  });
  return { mutateAsync };
};

export default useAddHostInfo;
